export default {
  loginMessage: { method: 'get', url: '/api/v1/auth/loginMessage' }, //获取签名字符串
  isRegister: { method: 'post', url: '/api/v1/auth/isRegister' }, //是否注册
  login: { method: 'post', url: '/api/v1/auth/login' }, //登录
  userInfo: { method: 'get', url: '/api/v1/user/info', config: { requiresToken: true } }, //用户信息
  teamList: { method: 'get', url: '/api/v1/user/zhiList', config: { requiresToken: true } }, //团队列表
  teamCount: { method: 'get', url: '/api/v1/user/myTeamCount', config: { requiresToken: true } }, //团队统计
  bannerList: { method: 'get', url: '/api/v1/common/bannerList' }, //获取banner列表
  noticeList: { method: 'get', url: '/api/v1/common/marquee' }, //获取公告列表
  getKlineList: { method: 'get', url: '/api/v1/common/priceHistory' }, //获取K线列表
  getHomeInfo: { method: 'get', url: '/api/v1/common/mainInfo' } //获取首页信息
}
